<template lang='pug'>
.subheader
  h1.subheader__title.tp-m-deci Holding
  h2.subheader__subtitle.tp-r-centi {{ lHolding.desholding }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SubHeader',

  data () {
    return {
      editableTabsValue: '1',
      role: ''
    }
  },

  methods: {
    ...mapGetters([
      'getListHoldingData'
    ])
  },

  computed: {
    lHolding () {
      let datosHolding = [{ desholding: '' }]
      if (this.$store.getters.getListHoldingData !== undefined) {
        if (this.$store.getters.getListHoldingData !== '') {
          datosHolding = this.$store.getters.getListHoldingData
        }
      }
      return datosHolding[0]
    }
  },

  mounted () {
    const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
    this.role = storageAppData.customer_role
  }
}
</script>

<style lang="scss" scoped>

.subheader {
  background-color:$--color-white;
  padding: rem(24) rem(28);
  display: flex;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,.1);

  &__title {
    margin-right: rem(24);
  }

  &__subtitle {
    margin-top: rem(4);
    text-transform: lowercase;
  }
}
</style>
